export abstract class ItemContent {
	abstract readonly type: string
}
